import "./HumanReproduction.module.css";
import Header from "@/reusable_sections/Header";
import Riproduzione from "./sections/Riproduzione";
import Percorso from "./sections/Percorso";
import Trattamenti from "./sections/Trattamenti";
import Footer from "@/reusable_sections/Footer";
export default function HumanReproductionPage() {
  return <div>
      <Header />
      <Riproduzione />
      <Percorso />
      <Trattamenti />
      <Footer />
    </div>;
}